import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-old-password',
  templateUrl: './change-old-password.component.html',
  styleUrls: ['./change-old-password.component.scss']
})
export class ChangeOldPasswordComponent implements OnInit {
  showcurrentpassErrorMsg: any;
  oldPassword: any;
  shownewpassErrorMsg: any;
  newPassword: any;
  showconfirmpassErrorMsg:any;
  confirmPassword:any;
  error: any;
  error5: any;
  token: any;
  email: any;
  error6: any
  constructor(private router: Router,public user:UserService,public route: ActivatedRoute) {
    this.route.queryParams.subscribe((res) => {
      this.token=res?.token;
     if(this.token!=null && this.token!==undefined){
    this.checkLinkValid()
  }
    });
   }

  ngOnInit(): void {
    //
    this.email=sessionStorage.getItem("loginUserEmail")
    if(this.token==null || this.token==undefined){
      this.token=null
    }
    else{
      this.email=null
    }
  }
  currentpassErrorMsg() 
  {
    if (!this.oldPassword) { this.showcurrentpassErrorMsg = true; } else { this.showcurrentpassErrorMsg = false }
  }
  newpassErrorMsg() 
  {
    if (!this.newPassword) { this.shownewpassErrorMsg = true; } else { this.shownewpassErrorMsg = false };
    // this.error5="";
    this.passwordValidate(this.newPassword)

  }

  confirmpassErrorMsg() 
  {
    if (!this.confirmPassword) { this.showconfirmpassErrorMsg = true; } else { this.showconfirmpassErrorMsg = false }
    this.ConfirmpasswordValidate(this.confirmPassword);
  }

  showNew = false;
  typeNew = "password";
  toggleShowNew() {
    this.showNew = !this.showNew;
    if (this.showNew) {
      this.typeNew = "text";
    }
    else {
      this.typeNew = "password";
    }
  }
  showConfirm = false;
  typeConfirm = "password";
  toggleShowConfirm() {
    this.showConfirm = !this.showConfirm;
    if (this.showConfirm) {
      this.typeConfirm = "text";
    }
    else {
      this.typeConfirm = "password";
    }
  }
  showCurrent = false;
  typeCurrent = "password";
  toggleShowCurrent() {
    this.showCurrent = !this.showCurrent;
    if (this.showCurrent) {
      this.typeCurrent = "text";
    }
    else {
      this.typeCurrent = "password";
    }
  }
  passwordChange() 
  {
    
      var flag = true;
      if (!this.oldPassword || this.oldPassword == "") { this.showcurrentpassErrorMsg = true; flag = false }
      if (!this.newPassword || this.newPassword == "") { this.shownewpassErrorMsg = true; flag = false }
      if (!this.confirmPassword || this.confirmPassword == "") { this.showconfirmpassErrorMsg = true; flag = false }

    if(this.oldPassword == this.newPassword){
      Swal.fire('Current password and New password cannot be the same!');
      flag = false;
        }
    if(this.newPassword != this.confirmPassword){
       Swal.fire('New password and Confirm password need to be the same!');
       flag = false;
        }
        if (flag == true) 
        {
          this.user.changeOldPassword(this.oldPassword, this.newPassword,this.email,this.token)
      .pipe()
      .subscribe(
          data => {
            
            if(data.success==true){
           this.router.navigateByUrl('/')
         //  Swal.fire('Password is updated successfully!')
          Swal.fire("", data.data)
            }
            else{
              Swal.fire("", data.data)
            }
          },error=>{
            
              if(error.status == 400 || error.status==417){
                  this.error=error.error.data;
               }
               else{
                Swal.fire("","Invalid current password")
                //  this.error="Something went wrong";
               }
           
              },()=>{});

        }
   }
   passwordValidate(pass){
    this.error5=""
   
    var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,16}$/;
    //
  if (!re.test(pass)) {
  this.error5="Please enter valid Password."
  }
  // if (!re.test(pass.match())){
  //   this.error5="Please enter valid Password"
  //   }
    if (pass.length <8){
      this.error5="Please enter valid Password."
      }
}
   ConfirmpasswordValidate(pass){
    this.error6=""
    var re =  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,16}$/;
    
  if (!re.test(pass)) {
  this.error6="Please enter valid Password."
  }

    if (pass.length <8){
      this.error6="Please enter valid Password."
      }
}
checkLinkValid(){  
  this.user.checkLinkValid(this.token)  
      .pipe()
      .subscribe(
          data => {            
            if(data.success==false){
              Swal.fire({
                title: data.data,                
                // backdrop: false, // Set to false to disable outside click closing
                allowOutsideClick: false, // Set to false to disable outside click closing
                confirmButtonText: "Ok",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigateByUrl('/')
                } 
              });
            }
           
          },error=>{  
              },()=>{});
}
}
